import Vue from 'vue';
import CButton from '@/components/Button.vue';
import FormInput from '@/components/FormInput.vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import BackButton from '@/components/BackButton.vue';

Vue.component('v-select', vSelect);
Vue.component('CButton', CButton);
Vue.component('FormInput', FormInput);
Vue.component('back-button', BackButton);
